import { useCitySelectionContext } from '../providers/CitySelectionProvider';

export const useSelectedCity = useCitySelectionContext;
